import { aiFetch as fetchData } from '@/utils/aiFetch'
import { buriedPointUtil, formatDate, isMobile } from '@/utils/utils'

export const retrieveDeepSearchList = (data) => {
  buriedPointUtil({ eventId: isMobile() ? 'HDR101' : 'PDR101' })
  return fetchData('/deep_search', {
    method: 'post',
    body: JSON.stringify({
      ...data,
      current_time: formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
    })
  })
}

export const deepSearchFeedback = (data) => {
  return fetchData('/feedback', {
    method: 'post',
    body: JSON.stringify({
      ...data,
      current_time: formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
    })
  })
}
